import React, { PureComponent } from "react";
import moment from "moment";
import { v4 as uuidV4 } from "uuid";
import Header from "../header/HeaderContainer/Header";
import Menu from "../menu/Menu";
import ModuleContainer from "../module-container/ModuleContainer";

import {
  isLoggedIn,
  navigateToAuthorizeEndpoint,
  loginWithAuthCode,
  qs,
  withEventDispatcher,
  EventSource
} from "clavis-nxt-components-custdevtm";

import { ModuleConfigContext } from "../ModuleConfigContext/ModuleConfigContext";
import { NotificationBar } from "../Notification/NotificationBar/NotificationBar";

class AppContainer extends PureComponent {
  static contextType = ModuleConfigContext;

  constructor(props) {
    super(props);
    this.state = {
      authInProgress: !isLoggedIn(),
      notification: this.storageEventHandlerDecisionCallback(),
      notificationKey: ""
    };
  }

  componentDidMount() {
    const parsedUrlParams = qs.parse(window.location.search);
    const authCode = parsedUrlParams.code;

    if (!isLoggedIn() && !!authCode) {
      console.log(`Found auth code: ${authCode}, requesting token with it...`);
      loginWithAuthCode(authCode, this.resolveGatekeeperConfig())
        .then(res => {
          console.log("Got token with auth code");
          if (res.success) {
            this.setState({ authInProgress: false });
          } else {
            navigateToAuthorizeEndpoint(this.resolveGatekeeperConfig());
          }
        })
        .catch(() => {
          console.log(
            "Error getting token with auth code, retrying authorize..."
          );
          navigateToAuthorizeEndpoint(this.resolveGatekeeperConfig());
        });
    }
    if (!isLoggedIn() && !authCode) {
      console.log("No token or auth code was found, invoking authorize...");
      navigateToAuthorizeEndpoint(this.resolveGatekeeperConfig());
    }
    window.addEventListener("system_message", this.storageEventHandler, false);

    this.props.eventDispatcher.subscribe(
      "platform-services",
      "SYSTEM_MESSAGE_UPDATE",
      EventSource.WS,
      this.storageEventHandler
    );
    this.props.eventDispatcher.subscribe(
      "platform-services",
      "SYSTEM_MESSAGE_DELETE",
      EventSource.WS,
      this.storageEventHandler
    );
  }

  componentWillUnmount() {
    window.removeEventListener("system_message", this.storageEventHandler);
  }

  /** Get gatekeeper config from context.
   *  @return {?Object} */
  resolveGatekeeperConfig = () =>
    this.context &&
    Object.hasOwn(this.context, "modules") &&
    Object.hasOwn(this.context.modules, "gatekeeper")
      ? this.context.modules.gatekeeper
      : null;

  /** System message event handler callback function.*/
  storageEventHandler = () =>
    this.setState({
      notification: this.storageEventHandlerDecisionCallback(),
      notificationKey: uuidV4()
    });

  /** Get storage event handler value.
   *  @return {boolean} */
  storageEventHandlerDecisionCallback = () => {
    const value = JSON.parse(localStorage.getItem("clavis.system_message"));
    return (
      value &&
      Object.keys(value).length > 0 &&
      moment(new Date()).isSameOrAfter(value.startTs, "minute") &&
      moment(new Date()).isSameOrBefore(value.endTs, "minute")
    );
  };

  render() {
    return this.state.authInProgress ? (
      <div className="app-container">Authentication is in progress...</div>
    ) : (
      <div className="app-container">
        <Header idleTimer={this.props.idleTimer} />
        {this.state.notification && (
          <NotificationBar key={this.state.notificationKey} />
        )}
        <div className="content-container">
          <Menu notification={this.state.notification} />
          <div
            id="module-container"
            className={`right-container ${
              this.state.notification
                ? "with-notification"
                : "without-notification"
            }`}
          >
            <ModuleContainer moduleConfig={this.context} />
          </div>
        </div>
      </div>
    );
  }
}

export default withEventDispatcher(AppContainer);
